
export default function AboutPage_section({website, section}) {
  return (
    <div className='aboutPage_section'>
        <h2>{section.header}</h2>
        <h4>{section.content}</h4>
    </div>
  )
}
